import { render, staticRenderFns } from "./CoproducerModal.vue?vue&type=template&id=6d50f717&"
import script from "./CoproducerModal.vue?vue&type=script&lang=js&"
export * from "./CoproducerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports